import React from 'react';
import { Flex, Image } from '@chakra-ui/react';
import { IPane, Pane } from './Pane/pane';

import { t } from 'i18next';
import { useMarketProvider } from 'src/providers/Market/marketProvider';
import { IconAssets } from 'src/config';

export const InfoSummary = () => {
	const { playersCount, gamesCount, price } = useMarketProvider();

	const panes: IPane[] = [
		{
			icon: <Image src={IconAssets.dollar} />,
			name: t('infoSummary.pane.hash').toString(),
			value: price,
			decorator: '$',
		},
		{
			icon: <Image src={IconAssets.users} />,
			name: t('infoSummary.pane.gamers').toString(),
			value: `${playersCount}`,
		},
		{
			icon: <Image src={IconAssets.save} />,
			name: t('infoSummary.pane.games').toString(),
			value: `${gamesCount}`,
		},
		{
			name: t('infoSummary.pane.creator.topic').toString(),
			value: t('infoSummary.pane.creator.subtopic').toString(),
			action: () => window.location.replace('https://GameXplorer.io/'),
		},
	];

	return (
		<Flex
			width="100%"
			background="#111111"
			border="1px solid #4E4F52"
			borderLeft="none"
			borderRight="none"
			alignItems="center"
			justifyContent="center"
			display={{ base: 'none', lg: 'flex' }}
		>
			<Flex minWidth="1240px">
				{panes.map(pane => (
					<Pane
						key={pane.name}
						data={pane}
					/>
				))}
			</Flex>
		</Flex>
	);
};
